export default __webpack_public_path__ + "static/media/Ayotunde1.86200c20.webp";